module.exports = __webpack_public_path__ + "static/what-americas-want-f2b01a4ad7a392dd7c9a2c14b5fb9756.png";